import {
  FileFolderItem,
  MissionDetailsSelection,
  RunDetailsSelection,
  useDataContext,
} from '@mobile-mapping/providers';
import { LoadState } from '@trimble/data-loading';
import { ProjectDataPanel } from '@trimble/project-data-panel-ui';
import {
  PROJECT_DATA_FILTER_OPTIONS,
  ProjectDataFilterMode,
} from '../project-data.types';
import { Spinner } from '@tcweb/connect-ui';
import { useSearchParams } from '@solidjs/router';
import { JSX, createMemo, Show } from 'solid-js';
import { SharedProjectDataTrees } from './SharedProjectDataTrees';

export interface SharedProjectDataPanelProps {
  onModelDetailsSelect?(model: FileFolderItem): void;
  onRunDetailsSelect?(run: RunDetailsSelection): void;
  onMissionDetailsSelect?(mission: MissionDetailsSelection): void;
}

export const SharedProjectDataPanel = (
  props: SharedProjectDataPanelProps
): JSX.Element => {
  const { dataState } = useDataContext();
  const [searchParams, setSearchParams] = useSearchParams<{
    pointCloudIds?: string;
    trajectoryIds?: string;
    modelIds?: string;
    filterMode?: string;
  }>();

  const hasDataInUrl =
    !!searchParams.pointCloudIds ||
    !!searchParams.trajectoryIds ||
    !!searchParams.modelIds;

  const initialFilterMode: ProjectDataFilterMode =
    searchParams.filterMode === 'all' || searchParams.filterMode === 'active'
      ? searchParams.filterMode
      : hasDataInUrl
        ? 'active'
        : 'all';

  const isAnyLoading = createMemo(() => {
    const isNotReady = (state: LoadState): boolean =>
      state === LoadState.Loading || state === LoadState.NotLoaded;

    return (
      isNotReady(dataState.trajectory.state) ||
      isNotReady(dataState.pointCloud.state) ||
      isNotReady(dataState.tcFileFolder.state) ||
      isNotReady(dataState.mission.state)
    );
  });

  const filterOptions = PROJECT_DATA_FILTER_OPTIONS().filter(
    (option) => option.key !== 'archived'
  );

  return (
    <ProjectDataPanel
      initialFilterMode={initialFilterMode}
      onFilterModeChange={(mode) => setSearchParams({ filterMode: mode })}
      filterOptions={filterOptions}
    >
      <Show
        when={!isAnyLoading()}
        fallback={
          <div class="h-[300px]">
            <Spinner show={true} />
          </div>
        }
      >
        <SharedProjectDataTrees
          onModelDetailsSelect={props.onModelDetailsSelect}
          onRunDetailsSelect={props.onRunDetailsSelect}
          onMissionDetailsSelect={props.onMissionDetailsSelect}
        />
      </Show>
    </ProjectDataPanel>
  );
};
